import React from 'react';
import PropTypes from 'prop-types';
import { BoxSizing } from '@codex-brightworld/basics';
import { DeviceProvider } from '@codex-brightworld/gadgets';
import Bundle from '../Bundle';

const Bundles = props => (
  <DeviceProvider>
    <BoxSizing>
      {props.bundles.map((bundle, index) => (
        <Bundle
          key={index}
          id={bundle.id}
          addons={bundle.addons}
          bundleType={bundle.bundleType}
          dateCreated={bundle.createdDate}
          discountLabel={bundle.discountLabel}
          heading={bundle.heading}
          priceDescription={bundle.priceDescription}
          product={bundle.product}
          onAddToBasket={props.onAddToBasket}
          translations={props.translations}
          totalPrice={bundle.totalPrice}
          totalSaving={bundle.totalSavings}
        />
      ))}
    </BoxSizing>
  </DeviceProvider>
);

Bundles.propTypes = {
  bundles: PropTypes.arrayOf(
    PropTypes.shape({
      ...Bundle.propTypes
    })
  ),
  onAddToBasket: PropTypes.func,
  translations: PropTypes.shape({})
};

Bundles.defaultProps = {
  bundles: [],
  onAddToBasket: () => {},
  translations: {}
};

export default Bundles;
